import React from 'react';

import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { lightBlue, grey } from '@material-ui/core/colors';

const useStyles = (value, open) => makeStyles(theme => ({
    root: {
        cursor: 'pointer',
        borderBottomColor: open ? theme.palette.primary.main : (value == "" ? lightBlue['100'] : grey['900'])
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: open ? theme.palette.primary.main : (value == "" ? lightBlue['100'] : grey['900']),
        pointerEvents: 'none',
        opacity: 0.4
        // backgroundColor: 'rgba(0, 0, 0, 0.04)'
    },
    isOpenNotValue: {
        position: 'relative',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        color: '#237fc2',
        marginTop: 5,
        paddingLeft: '16px'
    },
    isOpen: {
        position: 'relative',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        marginTop: 5,
        color: theme.palette.text.secondary,
        paddingLeft: '16px'
    },
    notOpen: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: "24px",
        letterSpacing: '0.13px',
        color: '#88898c',
        bottom: 0,
        marginTop: 16,
        paddingLeft: '16px'

    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px',
        marginTop: 6
    }
}));

export default function SelectBox({ children, value, label, open, CreateBox, handleClick, disabled, required, header, filter, bgcolor, maxHeight }) {

    const classes = useStyles(value, open)()
    return (
        <Box borderRadius='2px'>
            <Box position='relative'
                borderBottom={open ? 2 : 1}
                className={disabled ? classes.disabled : classes.root}
                height='51.92px'
                bgcolor={bgcolor || 'background.paper'}
                display='flex'
                color={disabled ? 'rgba(0, 0, 0, 0.38)' : 'none'}
                width='100%'
                onClick={handleClick}>
                <Box flexGrow={1} pl="12px">
                    <Typography className={open ? classes.isOpenNotValue : (value !== "" ? classes.isOpen : classes.notOpen)}>
                        {label}
                        {
                            required && <sup style={{ fontSize: open || value != "" ? 'smaller' : 'medium', position: 'absolute', marginLeft: 2 }}>*</sup>
                        }
                    </Typography>
                    {
                        value != "" && typeof value == 'string' ?
                            <Typography className={classes.TextValue}>{value}</Typography>
                            :
                            <Box className={classes.TextValue}>{value}</Box>
                    }
                </Box>
                <Box my='auto' mr={2}>
                    {open ? <ArrowDropUp fontSize="large" color='primary' /> : <ArrowDropDown fontSize="large" color='primary' />}
                </Box>

            </Box>
            <Collapse in={open} timeout="auto" unmountOnExit>

                <Box width='100%'>
                    {filter}
                    {header}
                    <Box bgcolor='background.paper' style={{ maxHeight: maxHeight || 200, overflow: 'auto' }}>
                        <List component="nav" disablePadding>
                            {children}
                        </List>
                    </Box>
                    {CreateBox}
                </Box>
            </Collapse>

        </Box >
    );
}
